import { atomWithStorage } from 'jotai/utils';

export const naturalLanguageSearchQueryAtom = atomWithStorage<string>(
  'naturalLanguageSearchQuery',
  '',
);
